import Image from 'next/image'
import { Icons } from "@assets/assets";
import clsx from 'clsx';
const CustomSubmitButton = ({ title }: { title: string }) => {
    return (
        <button
            type="submit"
            aria-label="Submit Your Resume"
            className={clsx(
                "group inline-flex items-center select-none cursor-pointer pb-7",
            )}
            style={{ width: "auto" }}
        >
            {/* Left pill with text */}
            <span
                className={clsx(
                    "h-[46px]",
                    "rounded-full flex items-center justify-center font-semibold leading-[100%] whitespace-nowrap transition-colors bg-white hover:bg-[#225BD4] hover:text-white text-[#00040b] border border-[#ECF0F6]",
                    "px-5 md:px-6",
                    "text-[16px]",
                )}
            >
                {title}
            </span>

            {/* Right icon pill */}
            <span
                className={clsx(
                    "w-[46px] h-[46px] ml-1",
                    "shrink-0 rounded-full grid place-items-center transition-colors bg-[#225BD4]",
                )}
            >
                <Image
                    src={Icons?.chevron}
                    alt="Arrow Icon"
                    width={14}
                    height={14}
                    className="transition-transform duration-300 rotate-0 group-hover:rotate-[-90deg]"
                    sizes="(max-width: 1024px) 100vw, 50vw"
                />
            </span>
        </button>
    )
}

export default CustomSubmitButton